import { SVGProps } from 'react'

import classNames from 'classnames'

import { CommonBookingIcon } from '@local/assets/icons'
import { MarkerPinIcon, MarkerPlaceDotIcon, MarkerVisitedIcon } from '@local/assets/icons/marker-cleanup'

import styles from './CategoryMarker.module.scss'

export interface CategoryMarkerProps {
  name?: string
  text?: string
  isSelected?: boolean
  isSingle?: boolean
  markerIcon?: (props: SVGProps<SVGSVGElement>) => JSX.Element
  type?: 'booking' | 'visited' | 'normal'
  ellipsis?: boolean
}

// 카테고리 마커
export default function CategoryMarker({
  isSelected = false,
  name,
  text,
  isSingle = false,
  markerIcon: MarkerIcon = MarkerPlaceDotIcon,
  type = 'normal',
  ellipsis = false,
}: CategoryMarkerProps) {
  const icon =
    type === 'booking' ? (
      <CommonBookingIcon className={styles.icon} aria-hidden="true" />
    ) : type === 'visited' ? (
      <MarkerVisitedIcon className={styles.icon} aria-hidden="true" />
    ) : (
      <MarkerIcon className={styles.icon_default} aria-hidden="true" />
    )

  return (
    <div
      className={classNames(styles.pin_marker, {
        [styles.selected]: isSelected,
        [styles.type_single]: isSingle,
      })}
    >
      <div className={styles.marker_inner}>
        <div className={styles.marker_area}>
          <MarkerPinIcon className={styles.icon_pin} aria-hidden="true" />
          <div className={styles.icon_area}>{icon}</div>
        </div>
        {name && (
          <div className={styles.info_area}>
            <div className={styles.tit_area}>
              <div className={classNames(styles.tit_inner, { [styles.type_ellipsis]: ellipsis })}>
                <span className={styles.name}>{name}</span>
              </div>
              <div className={styles.date_area}>
                <span className={styles.txt}>{text}</span>
              </div>
            </div>
          </div>
        )}
        {isSelected && <span className="place_blind">선택됨</span>}
      </div>
    </div>
  )
}
